import React, { useEffect, useState } from 'react';
import { DeliveryOptions } from '../components/DeliveryOptions';
import { getSupabaseErrorMessage, loadProducts } from '../data/repository';
import { Product } from '../data/types';
export function Pricing() {
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState('');
  useEffect(() => {
    void loadProducts().then(items => setProducts(items.filter(item => item.isActive !== false))).catch(loadError => setError(getSupabaseErrorMessage(loadError)));
  }, []);
  const categories = ['Napuhanci', 'Soft Play', 'Sport', 'Dodaci'];
  return <div className="min-h-screen bg-background py-12" data-id="element-646" data-mp="3h9jasb6nbz0o">
      <div className="max-w-4xl mx-auto px-4" data-id="element-647" data-mp="3cag5cpmr7qs6">
        <header className="text-center mb-14" data-id="element-648" data-mp="3cbraotvul6le">
          <h1 className="text-5xl font-display font-bold text-gray-900" data-id="element-649" data-mp="1fi6ay0jjchbh">
            Cjenik
          </h1>
          <p className="mt-4 text-xl text-gray-600" data-id="element-650" data-mp="1aibj9urxrnpd">
            Pregledan prikaz svih cijena najma.
          </p>
        </header>
        <div className="mb-12" data-id="element-651" data-mp="1ekdga056hhue">
          <DeliveryOptions data-id="element-652" data-mp="1eob1crbbgjgx" />
        </div>
        {error ? <p role="alert" className="rounded-2xl border border-red-200 bg-red-50 p-5 text-center text-red-800" data-id="element-653" data-mp="1jmmbz49fqy07">
            {error}
          </p> : products.length === 0 ? <p className="py-16 text-center text-gray-500" data-id="element-654" data-mp="19oy3zcmtju03">Učitavamo cjenik…</p> : <div className="space-y-10" data-id="element-655" data-mp="1xd7w0wamldzo">
            {categories.map(category => {
          const items = products.filter(item => item.category === category);
          if (!items.length) return null;
          return <section key={category} className="overflow-hidden rounded-3xl border border-gray-100 bg-white" data-id="element-656" data-mp="1sko8p7m4z4ho">
                  <h2 className="border-b border-gray-100 bg-gray-50 px-6 py-4 text-2xl font-bold text-gray-900" data-id="element-657" data-mp="2l1qu6izyoae1">
                    {category}
                  </h2>
                  {items.map(product => <div key={product.id} className="flex flex-col gap-3 border-b border-gray-100 p-6 last:border-0 sm:flex-row sm:items-center sm:justify-between" data-id="element-658" data-mp="2pyeb28kmpxcw">
                      <div data-id="element-659" data-mp="2gxpzdkipk936">
                        <h3 className="font-bold text-gray-900" data-id="element-660" data-mp="2h0kjtc1q1twl">
                          {product.name}
                        </h3>
                        {product.variants?.map(variant => <p key={variant.label} className="mt-1 text-sm text-gray-600" data-id="element-661" data-mp="276lkslwy2q8v">
                            {variant.label}: <strong data-id="element-662" data-mp="1y5nety2y48nn">{variant.price} €</strong>
                          </p>)}
                      </div>
                      <strong className="text-2xl text-primary" data-id="element-663" data-mp="1o90x3i5x1xpu">
                        {product.basePrice} €
                      </strong>
                    </div>)}
                </section>;
        })}
          </div>}
      </div>
    </div>;
}